import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import DefaultLocales from 'globals/locales/default';
import { observer } from 'mobx-react';
import FsButton from 'ui-elements/buttons/FsButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import reportLocales from 'globals/locales/report';
import Routes from 'routes';
import FsDialogTitle from 'ui-elements/modals/FsDialogTitle';
import { ModalState } from 'globals/types';
import { Box } from '@material-ui/core';
import {
  CustomDialog,
  DialogActions,
  DialogContent,
  RelativeSendButtonWrapperBox,
} from '../ReportModals.style-elements';
import { ReportChangeCategoryModalLocationStateProps } from '../ReportChangeCategoryModal/ReportChangeCategoryModal';

const { close: closeLabel } = DefaultLocales;

const {
  dialogTitle,
  alertTitle,
  alertDescription,
} = reportLocales.changeCategoryModalSuccess;

const ReportChangeCategoryModalSuccess: React.FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const modalState = location.state as ReportChangeCategoryModalLocationStateProps;
  const status = modalState?.success || false;
  const name = modalState?.name;
  const newCategory = modalState?.newCategory;
  const withSimilar = modalState?.withSimilar;
  const numberOfSimilar = modalState?.numberOfSimilar;

  const redirect = useCallback((): void => {
    history.push({ pathname: Routes.REPORT });
  }, [history]);

  const handleClose = (): void => {
    redirect();
  };

  useEffect(() => {
    if (status !== ModalState.SUCCESS) redirect();
  }, [status, redirect]);

  return (
    <CustomDialog
      disableEnforceFocus
      open
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      data-test="report-change-category-modal-success"
    >
      <FsDialogTitle
        id="report-change-category-modal-success"
        onClose={handleClose}
      >
        {dialogTitle}
      </FsDialogTitle>

      <DialogContent dividers>
        <Alert severity="success">
          <AlertTitle>
            <FsBodyBold>{alertTitle}</FsBodyBold>
          </AlertTitle>
          <FsBody>{alertDescription[0]}</FsBody>
          <Box marginTop={2}>
            <FsBody>
              {alertDescription[1]}{' '}
              <FsBodyBold component="span">{name}</FsBodyBold>{' '}
              {alertDescription[2]}{' '}
              <FsBodyBold component="span" style={{ whiteSpace: 'nowrap' }}>
                {newCategory}{' '}
              </FsBodyBold>
            </FsBody>
          </Box>
          {withSimilar && numberOfSimilar && (
            <Box marginTop={2}>
              <FsBody>
                {alertDescription[3]}{' '}
                <FsBodyBold component="span">{numberOfSimilar}</FsBodyBold>{' '}
                {alertDescription[4]}
              </FsBody>
            </Box>
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <RelativeSendButtonWrapperBox>
          <FsButton onClick={handleClose} variant="contained" color="primary">
            {closeLabel}
          </FsButton>
        </RelativeSendButtonWrapperBox>
      </DialogActions>
    </CustomDialog>
  );
};

export default observer(ReportChangeCategoryModalSuccess);
